import {Component, OnInit} from '@angular/core';
import {BlogService} from '../../service/blog.service';
import {ActivatedRoute} from '@angular/router';
import {SafeHtml} from '@angular/platform-browser';
import {DynamicHooksComponent} from 'ngx-dynamic-hooks';

/**
 * Renders a detail view for the blog item
 *
 * @author evandongen
 */
@Component({
	selector: 'blog-detail',
	template: ` @if (blogHtml) {
		<ngx-dynamic-hooks
				[options]="{ sanitize: false }"
				[content]="blogHtml.toString()">
		</ngx-dynamic-hooks>
	}`,
	standalone: true,
	imports: [DynamicHooksComponent],
})
export class BlogDetailComponent implements OnInit {
	blogId: string | null;
	blogHtml: SafeHtml | null = null;

	constructor(
		private blogService: BlogService,
		private route: ActivatedRoute,
	) {
	}

	ngOnInit() {
		this.blogId = this.route.snapshot.paramMap.get('blogId');

		if (this.blogId !== null) {
			this.blogService
				.getBlogDetail(this.blogId)
				.then(result => (this.blogHtml = result));
		}
	}
}
